import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';

export const getSponsoredApi = (productData = []) => {
    const config = {
        url: `/v2/sponsored-product`,
        credentials: 'include',
        apiHost: apiHosts.browse,
        excludeVersion: true,
        contentType: 'application/json',
        params: {
            productList: productData,
        },
    };

    return RestClient.post(config).then((json) => json);
};
